import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru B - sedan widok prawy
 */
export const AreaB_Sedan_Right: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="99"
      height="148"
      viewBox="0 0 99 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_sedan_right"
          x="0"
          y="0"
          width="99"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_b_sedan_right)">
        <path
          d="M62.7139 1.96777C50.8932 1.00105 40.023 0.713943 30.96 1.31055C21.7851 1.91452 15.0407 3.39563 11.0107 5.5625C8.45104 39.8457 5.52085 82.1434 3.35059 113.484L3.34961 113.488L2.02246 132.627C1.67174 137.665 1.35979 142.111 1.09668 145.816C2.2435 145.496 3.51614 145.126 4.91797 144.717C6.58857 144.229 8.43722 143.69 10.4551 143.126C20.2815 140.383 34.7398 139.411 48.8496 139.396C63.0743 139.38 77.4863 140.342 87.4746 141.689C90.6922 142.124 93.1854 142.522 95.124 142.879C96.0048 95.4816 96.9477 46.8041 97.751 6.13867C88.1634 4.5351 78.439 3.25388 62.7139 1.96777Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
